import { v4 as uuidv4 } from 'uuid';
import { CustomEventEmitter } from '../../core/CustomEventEmitter';
import { ConnectionEvents } from '../../globals/constant';
import { Connection } from './Connection';
export class Connections extends CustomEventEmitter {
    constructor() {
        super(...arguments);
        this.connections = new Map();
    }
    updateConnectionNumber(number) {
        const newConnections = [];
        if (this.length < number) {
            const length = this.length;
            for (let i = 0; i < number - length; i++) {
                newConnections.push(this.addConnection());
            }
        }
        else {
            throw new Error('Cannot downsize connection number, use reset() instead');
        }
        return newConnections;
    }
    get length() {
        return Object.keys(this.connections).length;
    }
    reset() {
        const length = this.length;
        for (let i = 0; i <= length; i++) {
            this.removeConnection();
        }
        return this;
    }
    get(name) {
        if (this.connections.get(name)) {
            return this.connections.get(name);
        }
        throw new Error(`Connection ${name} does not exist`);
    }
    list() {
        const connections = [];
        for (const connection of Object.values(this.connections)) {
            connections.push(connection);
        }
        return connections;
    }
    forEach(callback) {
        this.connections.forEach((connection, id, connections) => {
            callback(connection, id, connections);
        });
    }
    addConnection() {
        const name = uuidv4();
        this.connections.set(name, new Connection(name));
        for (const [, eventName] of Object.entries(ConnectionEvents)) {
            this.connections.get(name).on(eventName, (event) => this.emit(eventName, event));
        }
        return this.connections.get(name);
    }
    removeConnection() {
        const name = Object.keys(this.connections).shift();
        if (name) {
            if (this.connections.get(name)) {
                this.connections.get(name).off();
                this.connections.delete(name);
            }
        }
        return this;
    }
    ping() {
        this.connections.forEach((connection) => {
            connection.ping();
        });
        return this;
    }
}
